import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "mt-2 d-flex flex-wrap" }
const _hoisted_3 = ["onClick"]

import EmojiListContainer from "~/core-ui/vue/ui/emoji-selector/EmojiListContainer.vue";
import {internationalUrlIfNeeded} from "~/core-ui/ts/Constants";


const __default__ = {
    name: "OperatorApplicationSelectableStickerList"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    stickerPacks: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmojiListContainer, { class: "sticker-list" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stickerPacks, (pack) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pack.id,
          class: "mb-4"
        }, [
          _createElementVNode("h5", _hoisted_1, _toDisplayString(pack.descr), 1),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.stickers, (sticker) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sticker.id,
                class: "sticker selectable",
                onClick: ($event: any) => (_unref(emits)('select', sticker)),
                style: _normalizeStyle({
                        backgroundImage: `url(${_unref(internationalUrlIfNeeded)(sticker.url)})`
                    })
              }, null, 12, _hoisted_3))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})